<template>
    <div class="Sidebar"  v-if="$route.meta.guest == true && $route.path.indexOf('/appvk') === -1">
        <v-toolbar >
            <v-toolbar-items hover>
                <v-btn class="ma-0 pa-0" text light color="blue lighten-2" :ripple="true" style="outline:0" hover
                     @click="goToSite('https://chatway.ru')"
                >
                    <img class="ma-2" src="/chatway.svg"  height="50"/>
                </v-btn>
            </v-toolbar-items>
            <v-spacer></v-spacer>
            <v-toolbar-items class="hidden-sm-and-down">
                <v-btn text tile color="primary" v-if="$route['name'] === 'Home' || true"
                       @click="$router.push({ path: '/signup' })">Зарегистрироваться</v-btn>
                <v-btn text tile color="primary" v-if="$route['name'] === 'Home' || true"
                    @click="$router.push({ path: '/login' })"
                >Войти</v-btn>
            </v-toolbar-items>
            <v-menu >
                <template v-slot:activator="{ on }">
                    <v-app-bar-nav-icon v-on="on" class="hidden-md-and-up"></v-app-bar-nav-icon>
                </template>
                <v-list>
                    <v-list-item @click="$router.push({ path: '/signup' })">
                            <v-list-item-title>Зарегистрироваться</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="$router.push({ path: '/login' })">
                        <v-list-item-title>Войти</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-toolbar>
        <v-snackbar
                v-model="snackbar"
                bottom
                color="error"
                right
        >
            Ошибка в авторизации!
            <v-btn
                    dark
                    text
                    @click="snackbar = false"
            >
                Закрыть
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>
export default {
    name: 'Sidebar',
    data () {
        return {
            snackbar: false
        }
    },
    methods: {
        goToSite(url) {
            window.location.href = url
        }
    },
    watch: {
        '$route' (to, from) {
            if (to.query.error) {
                this.snackbar = true
                this.$router.push({ path: '/login' })
            }
        }
    },
    created() {
        if (this.$route.query.error) {
            this.snackbar = true
            this.$router.push({ path: '/login' })
        }
        document.title = 'Chatway'
    }
}
</script>

<style scoped>

</style>
